import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationData = createCrudVuexModule({
  namespaced: true,
  path: "/data",
  state: {
    infoItem: null,
    info: null,
    isInfoLoading: null,
  },
  getters: {
    infoItem: (state) => state.infoItem,
    info: (state) => state.info,
    isInfoLoading: (state) => state.isInfoLoading,
  },
  mutations: {
    infoItem: (state, value) => (state.infoItem = value),
    info: (state, value) => (state.info = value),
    isInfoLoading: (state, value) => (state.isInfoLoading = value),
  },
  actions: {
    async fetchInfo({ commit }, { item, pagination }) {
      commit("isInfoLoading", true);
      commit("infoItem", item);

      try {
        const response = await rest.post(`data/${item._id}/info`, { item, pagination });
        commit("info", response.data);
        return response;
      } finally {
        commit("isInfoLoading", false);
      }
    },

    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/data/add-from-library", payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});

export const organizationDataCategory = createCrudVuexModule({
  namespaced: true,
  path: "/data-category",
  state: {
    infoItem: null,
    info: null,
    isInfoLoading: null,
  },
  getters: {
    infoItem: (state) => state.infoItem,
    info: (state) => state.info,
    isInfoLoading: (state) => state.isInfoLoading,
  },
  mutations: {
    infoItem: (state, value) => (state.infoItem = value),
    info: (state, value) => (state.info = value),
    isInfoLoading: (state, value) => (state.isInfoLoading = value),
  },
  actions: {
    async fetchInfo({ commit }, { item, pagination }) {
      commit("isInfoLoading", true);
      commit("infoItem", item);

      try {
        const response = await rest.post(`/data-category/${item._id}/info`, { pagination });
        commit("info", response.data);
        return response;
      } finally {
        commit("isInfoLoading", false);
      }
    },
  },
});
